/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * SubscribeSmsAddonResultDtoBase
 * auto generated base class for the model SubscribeSmsAddonResultDtoModel.
 */
export const SubscribeSmsAddonResultDtoModelBase = ModelBase
  .named('SubscribeSmsAddonResultDto')
  .props({
    __typename: types.optional(types.literal("SubscribeSmsAddonResultDto"), "SubscribeSmsAddonResultDto"),
    /** Correlation id minted by the BFF; matches the requestUuid on the eventual SmsAddonSubscribed/Failed event */
    requestUuid: types.union(types.undefined, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class SubscribeSmsAddonResultDtoModelSelector extends QueryBuilder {
  get requestUuid() { return this.__attr(`requestUuid`) }
}
export function selectFromSubscribeSmsAddonResultDto() {
  return new SubscribeSmsAddonResultDtoModelSelector()
}

export const subscribeSmsAddonResultDtoModelPrimitives = selectFromSubscribeSmsAddonResultDto().requestUuid
